import Loadable from '@loadable/component';

const SSOLogin = Loadable(async () => import('./components/login/index.js'));

const ssoRoutes = {
  '/sso': {
    components: { main: SSOLogin }
  }
};

export default ssoRoutes;
